import(/* webpackMode: "eager" */ "/home/runner/work/MKFrameworkDocs/MKFrameworkDocs/app/projects/page.tsx");
